import React, { FC, Fragment, useMemo } from 'react';

import { useRoutesWithBreadcrumbs } from '../../context/BreadcrumbsContext';
import { Error404 } from '../ErrorPages';
import { AiLimits, AssignAttractions, CreateOrganization, EditOrganization, Organization, OrganizationsList, StripeFees } from './pages';

export const OrganizationsEntrypoint: FC = () => {
  const routesConfig = useMemo(() => [
    {
      label: 'Organizations',
      element: <OrganizationsList />,
      path: '/',
      index: true,
    },
    {
      label: 'Organization',
      element: <Organization />,
      path: '/:id',
    },
    {
      label: 'Create Organization',
      element: <CreateOrganization />,
      path: '/new',
    },
    {
      label: 'Assign Attractions',
      element: <AssignAttractions />,
      path: '/:id/assign-attractions',
    },
    {
      label: 'Edit Organization',
      element: <EditOrganization />,
      path: '/:id/edit',
    },
    {
      label: 'Prowizje Stripe',
      element: <StripeFees />,
      path: '/:id/stripe-fees',
    },
    {
      label: 'Limity AI',
      element: <AiLimits />,
      path: '/:id/ai-limits',
    },
    {
      path: '/*',
      element: <Error404 />,
    },
  ], []);

  const routes = useRoutesWithBreadcrumbs(routesConfig);

  return (
    <Fragment key="routes">{routes}</Fragment>
  );
};
